import _ from 'lodash';
import Device from '../Device';

const questions = [{
  model: 'evocharge',
  type: 'oauth',
  name: 'evocharge',
  label: 'step3OauthDeviceEvoCharge',
  showNext: false,
  required: true,
  advanceOnEnter: true,
  advanceOnValue: true,
  update: values => ({
    additionalFields: {
      type: 'gravity',
      mfg: 'evocharge',
      tags: JSON.stringify(_.get(values, 'tags') || {}),
      deviceTags: JSON.stringify(_.get(values, 'deviceTags') || {}),
    },
  }),
}];

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const EvoCharge = new Device('evocharge', { mfg: 'evocharge', questions, addDevice });

export default EvoCharge;
